import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SelectTituloViatico } from 'sharedComponents/select'

import { KeyEventUtil } from 'utils'

const TituloViaticoFormGroup = ({ vIdSocio, iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-entregaARenidr-cuentaContableHaber', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='SALIDA' htmlFor='select-entregaARenidr-tituloViatico' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idTituloViatico'>
          {({ field }) => (
            <SelectTituloViatico
              {...field}
              disabled={!vIdSocio || fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-entregaARenidr-tituloViatico'
              onKeyDown={onKeyDown}
              idSocio={vIdSocio}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TituloViaticoFormGroup)
